export default __webpack_public_path__ + "static/media/shoulder.e690538b.svg";